import IApplicationState from 'app/types/state';

export function getCurrentTeamMember(state: IApplicationState) {
  if (
    state.teamMembers.teamMembersById !== undefined
    && state.teamMembers.currentTeamMemberId !== undefined
  ) {
    return state.teamMembers.teamMembersById[state.teamMembers.currentTeamMemberId];
  }
  return {};
}

export function getCurrentFormTeamMember(state: IApplicationState) {
  return {
    ...getCurrentTeamMember(state),
    ...state.teamMembers.requestedData,
  };
}

export function getTeamMembers(state: IApplicationState) {
  return {
    ...state.teamMembers,
    currentTeamMember: getCurrentTeamMember(state),
    currentFormTeamMember: getCurrentFormTeamMember(state),
  };
}

export function getTeamMemberSummary(teamMember, dragSelected = false, rows = {}, splitType): any {
  const teamMemberSummary = {
    id: teamMember.id,
    mobile: teamMember.mobile,
    email: teamMember.email,
    fullName: teamMember.fullName,
    teams: { name: teamMember.teamName },
    selected: rows[teamMember?.id]?.selected,
    financialStatus: {
      owingNumber: teamMember.pendingPaymentCollectionsTotalCount,
      overdueNumber: teamMember.overduePaymentCollectionsTotalCount,
    },
    collected: {
      collected: teamMember?.paidPaymentCollectionsTotalAmount,
      total:
        teamMember?.overduePaymentCollectionsTotalAmount
        + teamMember?.paidPaymentCollectionsTotalAmount,
    },
    amount: rows[teamMember?.id]?.amount,
    quantity: rows[teamMember?.id]?.quantity,
    amountRow: false,
    splitType,
  };
  return teamMemberSummary;
}

export function getTeamMemberRowData(
  teamMember,
  splitType,
  row,
  rowSelected = {},
): any {
  const teamMemberRowData = {
    id: teamMember.id,
    fullName: teamMember.fullName,
    teams: { name: teamMember.teamName },
    splitType,
    id: row.id,
    selected: rowSelected?.selected,
    amount: row?.amount,
    quantity: row?.quantity,
    amountRow: false,
  };
  return teamMemberRowData;
}

export function getTeamMemberRowDataNew(
  row,
  splitType,
): any {
  const teamMemberRowData = {
    id: row.id,
    fullName: row.fullName,
    teams: { name: row.teamName },
    splitType,
    selected: row?.selected,
    amount: row?.amount,
    quantity: row?.quantity,
    className: row?.className,
    amountRow: false,
  };
  return teamMemberRowData;
}

// export function getTeamMemberRowState(
//   row,
// ): any {
//   const teamMemberRowState = {
//     id: row.id,
//     selected: row?.selected,
//     amount: row?.amount,
//     quantity: row?.quantity,
//     amountRow: false,
//   };
//   return teamMemberRowState;
// }
